<template>
  <div class="otoasters" :class="rootClasses">
    <transition-group name="otoaster">
      <div v-for="t in items" :key="t.key" :class="t.class" class="otoaster">
        <div class="otoaster__text">
          <OSvg :svg="t.icon" />
          <span class="otoaster__message" v-text="t.message" />
          <a class="otoaster__clear" @click="remove(t)">
            <OSvg svg="cross" />
          </a>
        </div>
      </div>
    </transition-group>
  </div>
</template>
<script>
import { ToasterVariants } from '@/enums/components'
import OSvg from '@/components/OSvg/OSvg'

export default {
  name: 'OToaster',
  components: {
    OSvg
  },
  data() {
    return {
      items: [],
      duration: 3000,
      position: 'bottom',
      variant: ToasterVariants.success,
      variants: ToasterVariants
    }
  },
  computed: {
    rootClasses() {
      return {
        ['otoasters--' + this.position]: this.position
      }
    },
    svg() {
      let svg = 'info'

      switch (this.variant) {
        case this.variants.success:
          svg = 'checkmark'
          break

        case this.variants.danger:
          svg = 'danger'
          break

        case this.variants.warning:
          svg = 'alert'
          break
      }

      return svg
    }
  },
  methods: {
    success(message, stay, duration, position = 'bottom', id) {
      this.add(message, { variant: 'success', timeout: duration, stay, icon: 'checkmark', position, ...(id ? { id } : {}) })
    },
    info(message, stay, duration, position = 'bottom', id) {
      this.add(message, { variant: 'info', timeout: duration, stay, icon: 'info', position, ...(id ? { id } : {}) })
    },
    warning(message, stay, duration, position = 'bottom', id) {
      this.add(message, { variant: 'warning', timeout: duration, stay, icon: 'alert', position, ...(id ? { id } : {}) })
    },
    danger(message, stay, duration, position = 'bottom', id) {
      this.add(message, { variant: 'danger', timeout: duration, stay, icon: 'danger', position, ...(id ? { id } : {}) })
    },
    add(message, { variant, timeout, stay, icon, position, id }) {
      this.position = position
      this.variant = variant

      const item = { message, class: this.itemClasses(variant), key: `${Date.now()}-${Math.random()}`, icon, id }
      this.items.unshift(item)
      if (!stay) {
        setTimeout(() => this.remove(item), timeout || this.duration)
      }
    },
    remove(item) {
      const index = this.items.findIndex((i) => i.id === item.id)
      if (index >= 0) {
        this.items.splice(index, 1)
      } else {
        const i = this.items.indexOf(item)
        if (i >= 0) {
          this.items.splice(i, 1)
        }
      }
    },
    itemClasses(variant) {
      return { ['otoaster--' + variant]: variant }
    }
  }
}
</script>

<style lang="postcss">
.otoasters {
  @apply fixed inset-x-0 w-full mx-auto;
  z-index: 1001;
  padding: 0 10%;
  pointer-events: none;

  &--top {
    top: 60px;
  }

  &--bottom {
    bottom: 60px;
  }
}

.otoaster {
  @apply p-4 pr-5 rounded-full max-w-2xl mx-auto mb-1;
  border: 1px solid transparent;
  width: 100%;
  height: 100%;
  line-height: 37px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);
  pointer-events: initial;

  &__message {
    display: inline-block;
    vertical-align: middle;
    width: 87%;
    padding-right: 4rem;
  }

  &__text {
    @apply flex font-body font-semibold align-baseline text-left text-sm justify-between items-center text-white leading-tight w-full;

    svg {
      @apply text-white fill-current stroke-current w-6;

      g,
      use {
        @apply text-white fill-current stroke-current;
      }
    }

    span {
      margin-left: 10px;
    }
  }

  &-enter-from,
  &-leave-to {
    opacity: 0;
    -webkit-transform: translateY(100%);
    transform: translateY(100%);
    transition: 0.4s ease;
  }

  &-enter-to {
    opacity: 1;
    transition: 0.4s ease;
  }

  &-leave-to {
    height: 0;
    border: 0;
    margin: 0 auto;
    box-shadow: none;
    overflow: hidden;
    transition: 0.4s ease;
  }

  &__clear {
    @apply relative no-underline float-right cursor-pointer;

    &::before {
      @apply absolute bottom-0 h-7 bg-white w-px;
      left: -2rem;
      top: 0;
      bottom: 0;
      margin: auto;
      content: '';
    }

    svg {
      @apply text-white fill-current stroke-current w-4;

      g,
      use,
      path {
        @apply text-white fill-current stroke-current;
      }
    }
  }

  &--info {
    @apply bg-blue-400;
  }

  &--danger {
    @apply bg-red-400;
  }

  &--success {
    @apply bg-green-300;
  }

  &--warning {
    @apply bg-orange-400;
  }
}
</style>
